import React, {Component} from 'react'
import FormMixin from '../shared/FormMixin'
import { connect } from 'react-redux'
import { Markdown, StyledForm, TextAgreement} from 'components'
import { DocumentActions } from 'actionsets'
import { Select } from 'components'
import Dependent from 'containers/shared/Dependent'
import StyleSheet from 'styles'
import {underscore} from 'utils'
import CenteredContent from 'containers/CenteredContent'
import Typography from '@material-ui/core/Typography'
import {SupportingDocuments} from 'containers/organisation'

export class Edit extends FormMixin(Component) {
  constructor(props) {
    super(props)
    DocumentActions.bindActions(this)
    this.onSaveRoute = false
    this.state = {
      ...this.state,
      document: 'investorTncs',
      termsAndConditionsPreview: {
        open: false
      },
      context: {},
    }
  }

  get formObjectName(){
    return 'Terms and Conditions'
  }

  get documentName() {
    return (this.state && this.state.document) || 'investorTncs'
  }

  get formObject() {
    return this.props[this.documentName]
  }

  get updatedFormObject() {
    return {...super.updatedFormObject, name: underscore(this.state.document)}
  }

  get saveActionName() {
    return 'update'
  }

  dependsOn() {
    return this.actions.show({name: underscore(this.state.document)})
  }

  dependenciesMet() {
    return !!this.formObject.id
  }

  handleTncsForChanged = (event) => {
    this.setState({document: event.target.value, attributes: {}}, () => this.dependsOn())
  }

  handleRequestOpenTsCsPreview = () => {
    this.setState({
      termsAndConditionsPreview: {
        open: true
      }
    })
  }

  closeTermsAndConditionsPreview = () => {
    this.setState({
      termsAndConditionsPreview: {
        open: false
      }
    })
  }

  renderTermsAndConditionsPreview() {
    const onCloseHandler = this.closeTermsAndConditionsPreview
    const mdtext = this.attribute('content')
    return (
      <TextAgreement
        title='Terms and Conditions (Preview)'
        open={this.state.termsAndConditionsPreview.open}
        onConfirm={onCloseHandler}
        onCancel={onCloseHandler}
        disabled
      >
        <Markdown mdtext={mdtext}/>
      </TextAgreement>
    )
  }

  render = () => {
    const { MarkDownField, Button } = this
    return (
      <div style={{width: '100%'}}>
        <CenteredContent style={{paddingBottom: 0}}>
          <StyledForm style={{maxWidth: 553}}>
            <Typography variant={'h5'}>Legal Documents</Typography>
            <div className={styles.section}>
              <Select label="Document" value={this.state.document}
                      onChange={this.handleTncsForChanged}
                      options={documentOptions} />
              <MarkDownField label='Terms & Conditions' attribute='content' onRequestOpenPreview={this.handleRequestOpenTsCsPreview}/>
              {this.renderTermsAndConditionsPreview()}
              <Button onClick={this.save} variant='contained' color='primary' fullWidth>Save</Button>
            </div>
          </StyledForm>
        </CenteredContent>
        <SupportingDocuments/>
      </div>
    )
  }

}

const documentOptions = [
  {label: 'Investor Terms & Conditions', value: 'investorTncs'},
  {label: 'Issuers Terms & Conditions', value: 'issuerTncs'},
  {label: 'Aml Document List', value: 'amlInfo'},
  {label: 'Certification Conditions', value: 'certAgreement'},
  {label: 'Risk Disclaimer', value: 'riskDisclaimer'},
  {label: 'Unsupported Country Message', value: 'unsupportedCountry'},
  {label: 'KYC Information Consent', value: 'kycConsent'}
]

const styles = StyleSheet({
  wrapper: {
    display: 'flex',
    flex: 1
  },
  section: {
    marginBottom: 50,
    position: 'relative'
  },
})

export default connect(({documents}) => (documents))(Dependent({loader: true, wrapperClassName: styles.wrapper, clearOnLoad: true})(Edit))